﻿
var ready, isReady, readyList, completed, fire, detach;
var addEventListenerSupported;

isReady = false;
readyList = [];
addEventListenerSupported = !!document.addEventListener;

ready = function (fn) {
    if (isReady) {
        fn();
    } else {
        readyList.push(fn);
    }
};

completed = function () {
    if (isReady) return;

    isReady = true;
    detach();

    fire();
};

fire = function () {
    var i;
    for (i = 0; i < readyList.length; i++) {
        readyList[i]();
    }
};

detach = function () {

    if (addEventListenerSupported) {

        document.removeEventListener("DOMContentLoaded", completed, false);
        window.removeEventListener("load", completed, false);

    } else {

        document.detachEvent("onreadystatechange", completed);
        window.detachEvent("onload", completed);

    }
};

isReady = ("complete" == document.readyState);

if (!isReady) {

    if (addEventListenerSupported) {

        document.addEventListener('DOMContentLoaded', completed, false);
        window.addEventListener('load', completed, false);

    } else {

        document.attachEvent('onreadystatechange', completed);
        window.attachEvent("onload", completed);

    }

}

module.exports = ready;